import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MipIconModule } from '@libs/gc-common/lib/components/mip-icon/mip-icon.module';

import { ShareModalComponent } from './share-modal.component';

@NgModule({
  declarations: [
    ShareModalComponent
  ],
  imports: [
    CommonModule,
    MatListModule,
    MipIconModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatSnackBarModule
  ]
  /*providers: [
   ShareModalService
   ]*/
})
export class ShareModalModule {
}
